/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import NewSelectInput from "../../../components/NewSelectInput";
import ListView from "../../../components/common/ListView";
import TextareaField from "../../../components/common/TextareaField";
import { useState } from "react";

const inventoryData = [
  {
    id: 1,
    awb: "654654654654",
    status: "Out for delivery",
  },
  {
    id: 2,
    awb: "654654654654",
    status: "Dispatch",
  },
  {
    id: 3,
    awb: "654654654654",
    status: "Delivered",
  },
  {
    id: 4,
    awb: "654654654654",
    status: "Undelivered",
  },
  {
    id: 5,
    awb: "654654654654",
    status: "Undelivered",
  },
];

const BulkStatusRevertModal = () => {
  const [awbText, setAwbText] = useState("");

  return (
    <div className="w-full py-4 pr-2 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
      <div className="p-4 space-y-4">
        <NewSelectInput label="Choose Status" name={""} selectOptions={[]} />
        <TextareaField
          rows={4}
          label={"Reason"}
          placeholder={"Enter Reason"}
          name={""}
        />
      </div>
    </div>
  );
};

export default BulkStatusRevertModal;
